export default {
  EnteredValueIsCumulative: 'enteredValueIsCumulative',
  EnteredValueIsDelta: 'enteredValueIsDelta',
}
